import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { CapTableDirtyCellStore } from './types';

const useCapTableDirtyCellStore = create<CapTableDirtyCellStore>()(
  devtools(
    set => ({
      dirtyBySecurityId: {},

      recordDirty: (securityId, alias, value) =>
        set(
          state => ({
            dirtyBySecurityId: {
              ...state.dirtyBySecurityId,
              [securityId]: { ...state.dirtyBySecurityId[securityId], [alias]: value },
            },
          }),
          false,
          'recordDirty'
        ),

      clearField: (securityId, alias) =>
        set(
          state => {
            const forSecurity = state.dirtyBySecurityId[securityId];
            if (!forSecurity || !(alias in forSecurity)) {
              return state;
            }
            const rest = { ...forSecurity };
            delete rest[alias];
            const next = { ...state.dirtyBySecurityId };
            if (Object.keys(rest).length === 0) {
              delete next[securityId];
            } else {
              next[securityId] = rest;
            }
            return { dirtyBySecurityId: next };
          },
          false,
          'clearField'
        ),

      clearAll: () => set(() => ({ dirtyBySecurityId: {} }), false, 'clearAll'),
    }),
    { name: 'CapTableDirtyCellStore' }
  )
);

export default useCapTableDirtyCellStore;
